module.exports = __webpack_public_path__ + "static/media/btn-arrow-right.38699b18.svg";